export const replaceString = (
  string: string,
  { key, value }: { key: string; value: string }
) => {
  return string.replace(`{${key}}`, value)
}
